<template>
  <div>

  <!-- debug code only shows if this.showDebug is true -->
    <v-card v-if="showDebug">
    Subscription is required after: {{ subscriptionsDeadline }}</br>
    {{ !orgIsSubscribed ? "Org is NOT subscribed" : "Org is subscribed" }}<br/>
    {{
      propertyIsPublished
        ? "Property is published"
        : "Property is NOT published"
    }}<br/>
    {{ showUnpublishedOverlay ? "Unpublished overlay is SHOWING" : "Unpublished overlay is HIDDEN" }}<br/>
    <div v-if="userIsAuthenticated" style="margin: 10px 0">
      <a
        href="#"
        @click.prevent="$store.dispatch('logout')"
        style="color: red; text-decoration: underline"
      >
        Logout (Set userIsAuthenticated to false)
      </a>
    </div>
    </v-card>
  <!-- End of debug code only shows if this.showDebug is true -->

    <ehc-unpublished-overlay
      opacity=".8"
      class="text-h5"
      v-if="showUnpublishedOverlay"
    >
      Oops! This listing is currently not available.<br /><br />Please contact
      your host or listing agent.
      {{
        !orgIsSubscribed
          ? "The organization subscription may have expired."
          : ""
      }}
      <span class="d-block mt-8">
        <v-btn color="white" outlined @click="goToOwnerLogin">
          Property owner? Log in
        </v-btn>
      </span>
    </ehc-unpublished-overlay>

    <!-- S...{{ orgIsSubscribed }} P...{{ propertyIsPublished }} -->

    <div class="ehc-propavatar">
      <v-avatar :size="avatarSize" class="avatar">
        <v-img :src="avatarImg" alt="Property Name"> </v-img>
      </v-avatar>
      <!-- <v-btn 
        small 
        class="ma-auto ehc-propavatar-edit" 
        fab 
        v-if="userIsAuthenticated" 
        icon 
        @click="imagePopup = !imagePopup">
          <v-icon>mdi-pencil</v-icon>
      </v-btn>   -->
      <div class="ehc-propavatar-edit" v-if="userIsAuthenticated">
        <v-img src="@/assets/icons/base.svg" max-height="48" max-width="48">
          <v-img
            src="/img/camera.fill_black.svg"
            max-height="30"
            max-width="30"
            class="ehc-propavatar-edit-camera"
            @click="imagePopup = !imagePopup"
          ></v-img>
        </v-img>
      </div>
    </div>
    <ehc-image-upload
      circle
      v-model="imagePopup"
      title="Upload Property Image"
      :uploadPath="
        '/propertyPictures/' + property.propertyId + Date.now() + '500x500'
      "
      instructions="Select image to upload and insert"
      :size="{
        width: 500,
        height: 500,
      }"
      @upload="setAvatarURL($event)"
      :persistent="isMobile"
    />

    <!-- <ehc-dialog 
      v-model=imagePopup 
      title="Upload Property Image"
      close
      >
      <component-info-image @closeDialog = closeImageDialog :askDescription=false :isAvatarImg=true>
        <template slot="header">
        </template>
        <template slot="instructions">
          <p>Square images will look better.</p>
        </template>
      </component-info-image>
    </ehc-dialog> -->
  </div>
</template>

<script>
import componentInfoImage from "./component-info-image.vue";
import ehcImageUpload from "@/components/ehc-image-upload.vue";
import EhcUnpublishedOverlay from "./ehc-unpublished-overlay.vue";
import mixins from "@/mixins";
import api from "@/mixins/api.vue";

export default {
  components: { componentInfoImage, ehcImageUpload, EhcUnpublishedOverlay },
  mixins: [mixins, api],
  data() {
    return {
      propertyNameFontColor: "blue-grey",
      imagePopup: false,
      showDebug: false, //! controls display of debug info
    };
  },
  computed: {
    // isPublished: function(){
    //   if ( !this.property.publishedAt || this.property.deletedAt !== null ) { return false }
    //   return true
    // },
    property() {
      return this.$store.getters.property;
    },
    avatarSize: function () {
      if (window.outerWidth < 600) {
        return 150;
      }
      return 125;
    },
    avatarImg: function () {
      return this.$store.getters.property.avatarImg;
    },
    // published: function(){
    //   return this.$store.getters.property.publishedAt
    // },
    pageImage: function () {
      let homeImage = this.$store.getters.images.filter((el) => {
        return el.homeImage === true;
      });
      // console.log(homeImage.length)
      if (homeImage.length) {
        return homeImage[0];
      }
      return this.$store.getters.images[0];
    },
    cssTitleClass: function () {
      return `mb-5 ${this.propertyNameFontColor}--text text--darken-4 text-h5 text-sm-h4 text-md-h3`;
    },
    pageTitle: function () {
      return this.$store.getters.property.name;
    },
    showUnpublishedOverlay: function () {
      if (this.userIsAuthenticated) {
        return false;
      }

      // Owners must be able to reach the login form to edit unpublished guides.
      if (this.$route.name === "Login" || this.$route.name === "Signin") {
        return false;
      }

      // Property not loaded yet — never flash "unavailable" during initial fetch
      if (!this.property || !this.property.propertyId) {
        return false;
      }

      if (!this.propertyIsPublished) {
        return true;
      }

      // Wait for app settings before applying the subscription deadline gate
      if (!this.$store.getters.appSettings) {
        return false;
      }

      // Only check subscription status after the deadline
      if (this.subscriptionsDeadline) {
        const now = new Date();
        const deadline = new Date(this.subscriptionsDeadline);

        if (now > deadline) {
          const org = this.$store.getters.organization || {};
          // Org still loading — don't flash unavailable for a published guide
          if (this.property.orgId && Object.keys(org).length === 0) {
            return false;
          }

          // After deadline, check if org is subscribed with additional grace period
          if (!this.orgIsSubscribed) {
            // Add configurable grace period for Stripe re-subscriptions
            if (org.account && org.account.expires) {
              const expirationDate = new Date(org.account.expires);
              const baseGracePeriod = this.gracePeriod || 0;
              const additionalGracePeriod =
                this.$store.getters.appSettings?.expirationGracePeriodDays || 2; // Default to 2 days
              const totalGracePeriodDays =
                baseGracePeriod + additionalGracePeriod;
              const finalGraceDate = new Date(
                expirationDate.getTime() +
                  totalGracePeriodDays * 24 * 60 * 60 * 1000,
              );

              // Only show overlay if we're past the final grace period
              if (now > finalGraceDate) {
                return true;
              }
            } else {
              // If no expiration date, show overlay immediately when not subscribed
              return true;
            }
          }
        }
      }

      return false;
    },
    subscriptionsDeadline() {
      // Return null if appSettings is not loaded yet
      if (!this.$store.getters.appSettings) {
        return null;
      }

      // Add your logic here to compute the subscriptions deadline
      // Example:
      return this.$store.getters.appSettings.subscriptionsDeadline;
    },
  },
  methods: {
    goToOwnerLogin() {
      const propertyId =
        (this.property && this.property.propertyId) ||
        this.$store.getters.propertyId ||
        this.$route.params.propertyId;
      if (propertyId) {
        this.$router.push({ name: "Login", params: { propertyId } });
        return;
      }
      this.$router.push({ name: "Signin" });
    },
    async setAvatarURL(URL) {
      this.apiUpdateProperty(this.property.propertyId, { avatarImg: URL }).then(
        () => {
          this.$store.commit("updateProperty", { avatarImg: URL });
        }
      );
    },
    setPropertyNameFontColor() {
      let backgroundColor =
        this.$route.query.background || this.property.backgroundColor;
      this.propertyNameFontColor = this.backgroundImages.filter(
        (el) => el.name === backgroundColor
      )[0].propertyNameColor;
    },
    closeImageDialog() {
      this.imagePopup = false;
    },
  },
  watch: {},
};
</script>

<style scoped>
.avatar {
  border: solid 7px white;
}
.v-btn {
  background-color: rgba(255, 255, 255, 0.8);
}

.ehc-propavatar-edit {
  /* center inside parent div with class of ehc-propavatar*/
  position: absolute;
  top: 0px;
  left: 50%;
  z-index: 1;
  transform: translate(30px, 75px);
}

.ehc-propavatar-edit-camera {
  /* align center */
  color: white;
  position: absolute;
  top: 45%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  /* make clickable */
  cursor: pointer;
}
</style>
